import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, switchMap, take } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { AllocationViewFiltersModel } from '../../../allocation-view/models';
import { AllocationViewFilterProfileModel } from '../../models';
import {
  AllocationViewFilterProfileItemCreate,
  AllocationViewFilterProfileItemDelete,
  AllocationViewFilterProfileItemGetSelected,
  AllocationViewFilterProfileItemInitialState,
  AllocationViewFilterProfileItemLoad,
  AllocationViewFilterProfileItemSet,
  AllocationViewFilterProfileItemUpdate,
} from './allocation-view-filter-profile-item.actions';

import { AllocationViewFilterProfileItemState } from './allocation-view-filter-profile-item.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewFilterProfileItemFacade implements LoadDataFacade, SetInitialStateFacade {
  selectedProfile$: Observable<AllocationViewFilterProfileModel> = this.store.select(
    AllocationViewFilterProfileItemState.getSelectedProfile,
  );
  loaded$: Observable<boolean> = this.store.select(AllocationViewFilterProfileItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewFilterProfileItemGetSelected());
  }

  loadFilterProfileById(id: number): Observable<AllocationViewFilterProfileModel> {
    return this.store
      .dispatch(new AllocationViewFilterProfileItemLoad(id))
      .pipe(switchMap(() => this.selectedProfile$.pipe(take(1))));
  }

  createFilterProfile(name: string, filter: AllocationViewFiltersModel): void {
    this.store.dispatch(new AllocationViewFilterProfileItemCreate({ name, filter }));
  }

  setFilterProfile(item: AllocationViewFilterProfileModel): void {
    this.store.dispatch(new AllocationViewFilterProfileItemSet(item));
  }

  updateFilterProfile(item: AllocationViewFilterProfileModel): void {
    this.store.dispatch(new AllocationViewFilterProfileItemUpdate(item));
  }

  deleteFilterProfile(id: number, callback?: () => void): void {
    this.store.dispatch(new AllocationViewFilterProfileItemDelete(id, callback));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewFilterProfileItemInitialState());
  }
}
